import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FakturPajakKeluaranComponent } from './faktur-pajak-keluaran.component';
import { MatStepperModule } from '@angular/material/stepper';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { AngularFileDropzoneModule} from 'angular-file-dropzone';

@NgModule({
  imports: [
    CommonModule,
    MatStepperModule,
    MatCardModule,
    MatButtonModule,
    FlexLayoutModule,
    MatSnackBarModule,
    AngularFileDropzoneModule,
    FormsModule
  ],
  declarations: [FakturPajakKeluaranComponent],
  exports: [FakturPajakKeluaranComponent]
})
export class FakturPajakKeluaranModule { }



// WEBPACK FOOTER //
// ./src/app/faktur-pajak-keluaran/faktur-pajak-keluaran.module.ts